
<template>
  <div class="container-fluid p-0">

    <component is="style">

      /*

      Not used at the moment...

      */

    </component>

    <div class="row">
      <div class="col-12 col-md-6 mail-editor" style="margin:auto;margin-top:0px;">
        <div class="content-fluid">
          <div class="row">
            <div class="col px-0 mx-0">
              <h1 class="mt-3 mt-md-0">How will your email look:</h1>
            </div>
          </div>
          <div class="row">
            <div class="col px-0 mx-0">
              Subject: <b>{{subject}}</b>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col px-0 mx-0">
              From: no-reply@iprocedo.com
            </div>
          </div>
          <div class="row">
            <div class="col p-4" v-bind:style="getDocumentStyle()">
              <div style="border:0px solid #000;border-radius:10px;color:#ffffff;display:inline-block;min-height:300px;padding:20px;text-decoration:none;width:100%;-webkit-text-size-adjust:none;mso-hide:all;" v-bind:style="getContentStyle()">
                <div v-html="body"></div>
                <div style="text-align:center;margin-top:30px;">
                  <div style="border: 1px solid #ccc; border-radius: 4px;  display: inline-block; font-weight: bold; text-align: center; text-decoration: none; min-width: 100px; -webkit-text-size-adjust: none; mso-hide: all; padding: 5px; padding-left: 10px; padding-right: 10px;" v-bind:style="getButtonStyle()">
                    {{buttonText}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <form class="login-formx form-validate" action="index.html" onsubmit="return false" id="createTemplateMail">

          <div class="col px-0 mx-0">
            <h1 class="mt-3 mt-md-0">Customize your mail</h1>
          </div>
          <div class="col px-0 pr-2 p-md-3 mx-0" style="height:400px;overflow-y:auto;">
            <div class="row px-0 mx-0">
              <div class="col-12 mt-1 px-0" v-show="false">

                <div class="custom-control custom-checkbox custom-control-inline">
                  <input class="custom-control-input chk-task-success" name="check_published" id="check_published" type="checkbox" v-model="published" v-bind:checked="published == true" />
                  <label class="custom-control-label chk-task-success" for="check_published">
                    Published
                  </label>
                </div>
              </div>
              <!--<div class="col-12 mt-3 custom-form-label px-0">
                Load template
              </div>
              <div class="col-12 mt-1 px-0">

                <select v-model="selectedTemplate" class="form-control" @change="loadTemplate">
                  <option value="">Choose template</option>
                  <option v-for="template in templates" v-bind:value="template.Id">{{template.Name}}</option>
                </select>

              </div>
              <div v-if="templatetype==null || templatetype==0" class="col-12 mt-3 custom-form-label px-0">
                Template type
              </div>
              <div v-if="templatetype==null || templatetype==0" class="col-12 mt-1 px-0">

                <select required v-model="mailType" class="form-control" v-bind:id="'select_templatetype_' +  getId()">
                  <option value="">Choose template type</option>
                  <option v-for="templatetype in templatestype" v-bind:value="templatetype.id">{{templatetype.name}}</option>
                </select>

              </div>
              <div class="col-12 mt-3 custom-form-label px-0">
                Name
              </div>
              <div class="col-12 mt-1 px-0">
                <input required type="text" class="form-control" v-model="name" />
              </div>-->
              <div class="col-12 mt-3 custom-form-label px-0">
                Subject
              </div>
              <div class="col-12 mt-1 px-0">
                <input required type="text" class="form-control" v-model="subject" />
              </div>
              <div class="col-12 mt-3 custom-form-label px-0">
                Body
              </div>
              <div class="col-12 mt-1 px-0">
                <mce-editor toolbar="undo redo | styleselect | outdent indent backcolor fontselect fontsizeselect forecolor" v-bind:doinit="false" ref="mce" v-model="body" name="description"></mce-editor>
              </div>
              <div class="col-12 mt-3 custom-form-label px-0">
                Button text
              </div>
              <div class="col-12 mt-1 custom-form-label px-0">
                <input type="text" class="form-control" v-model="buttonText" />
              </div>
              <div class="row px-0 mt-3 mb-3 px-0">
                <div class="col-12 p-0">
                  <a href="#" class="btn btn-light ml-2 px-1" @click="reset()">Cancel</a>
                  <a href="#" class="btn btn-light ml-2 px-1" @click="apply">Apply</a>
                  <a v-show="id == null || id <= 0" href="#" class="btn btn-light ml-2 px-1" @click="save()">Save</a>
                  <a v-show="id>0 && id!==null" href="#" class="btn btn-light ml-2 px-1" @click="update()">Update</a>
                </div>
              </div>

              <container-expand-right class="mt-2 px-0" v-bind:show="false" v-bind:title="'Colors and appearance'">
                <div class="container-fluid">
                  <div class="col-12 mt-3 custom-form-label">
                    Mail background color
                  </div>
                  <div class="col-12 mt-1">
                    <input-color-selector v-model="mailBGColor"></input-color-selector>
                  </div>

                  <div class="col-12 mt-3 custom-form-label">
                    Mail content color
                  </div>
                  <div class="col-12 mt-1">
                    <input-color-selector v-model="mailContentBGColor"></input-color-selector>
                  </div>

                  <div class="col-12 mt-3 custom-form-label">
                    Text color
                  </div>
                  <div class="col-12 mt-1 mb-3">
                    <input-color-selector v-model="mailTextColor"></input-color-selector>
                  </div>

                  <div class="col-12 mt-3 custom-form-label">
                    Button background color
                  </div>
                  <div class="col-12 mt-1 mb-3">
                    <input-color-selector v-model="buttonColor"></input-color-selector>
                  </div>

                  <div class="col-12 mt-3 custom-form-label">
                    Button text color
                  </div>
                  <div class="col-12 mt-1 mb-3">
                    <input-color-selector v-model="buttonForegroundColor"></input-color-selector>
                  </div>
                </div>
              </container-expand-right>

              <container-expand-right class="mt-2 px-0" v-show="false" v-bind:title="'Export/Import'">
                <div class="container-fluid">
                  <div class="row px-3 mt-3">
                    <div class="col-12 p-0">
                      <a href="#" class="btn btn-light" @click="exportData()">Export</a>
                      <a href="#" class="btn btn-light ml-2" @click="importData()">Import</a>
                    </div>
                  </div>
                  <div class="row px-3 mt-3  mb-3">
                    <div class="col-12 p-0">
                      <textarea class="form-control" v-model="importTxt"></textarea>
                    </div>
                  </div>
                </div>

              </container-expand-right>
            </div>

          </div>






        </form>
      </div>

    </div>
  </div>
</template>

<script>

  import UploadButton from "../upload/upload-button.vue";
  var body = 'Example body';
  var mailBGColor = '#e7e7e7';
  var mailContentBGColor = '#c7c7c7';
  var buttonColor = '#2AB963';
  var buttonForegroundColor = '#fff';
  var mailTextColor = 'black';
  var gtmId = null;
  var gtmCampaignId = null;
  var gtmCampaignName = null;
  var useGTMTracking = false;
  var logoFileId = null;
  var id = 0;

  export default {
    name: 'mail-editor-user',
    components: {
      UploadButton
    },

    data() {
      return {
        importTxt: "",
        published: true,
        templateId: -1,
        name: '',
        selectedTemplate: null,
        body,
        buttonColor,
        buttonForegroundColor,
        mailBGColor,
        mailContentBGColor,
        mailTextColor,
        gtmId,
        gtmCampaignId,
        gtmCampaignName,
        useGTMTracking,
        logoFileId,
        buttonText: 'Do something!!!',
        fileId: null,
        mailType: 0,
        subject: 'This is the subject',
        templates: [],
        templatestype: [],
        id: 0,
      }
    },

    props: {
      templatetype: {
        required: false,
        type: Number,
        default: 0
      },
    },
    methods:
    {
      getId() {
        return this._uid;
      },
      getDocumentStyle() {
        return "background-color:" + this.mailBGColor;
      },
      getContentStyle() {
        return "background-color:" + this.mailContentBGColor + ";color:" + this.mailTextColor;
      },
      getButtonStyle() {
        return "background-color:" + this.buttonColor + ";color:" + this.buttonForegroundColor;
      },
      exportData() {
        this.importTxt = JSON.stringify(this.getData());
      },
      importData() {
        var data = JSON.parse(this.importTxt);
        this.populateData(data);
      },
      changeBackgroundImage(url, name, settings) {
        $("#backGroundImageInput").val(url)
        var e = document.createEvent('HTMLEvents');
        e.initEvent('input', true, true);
        $("#backGroundImageInput")[0].dispatchEvent(e);
      },
      toggleExpansion() {
        if (!this.$refs.skinEditorPanels.isExpanded()) {
          this.$refs.skinEditorPanels.showRight();
        }
        else {
          this.$refs.skinEditorPanels.hideRight();
        }
      },

      reset() {

        this.id = null;
        this.name = '',
          this.published = false,
          this.body = 'Some body..';
        this.buttonText = 'Some button text';
        this.fileId = null;
        this.mailType = 1;
        this.subject = "the subject";

        this.mailBGColor = '#fff'
        this.buttonColor = '#2AB963';
        this.mailContentBGColor = 'green'
        this.mailTextColor = 'black'
        this.gtmId = null;
        this.gtmCampaignId = null;
        this.gtmCampaignName = null;
        this.useGTMTracking = false
        this.logoFileId = null

        var thisContext = this;

        this.$forceUpdate();

        setTimeout(function () {
          thisContext.resetColorPicker();
        }, 200);

      },

      populateData(template) {

        this.id = template.Id;
        this.name = template.Name,
          this.published = template.Published,
          this.body = template.Body;
        this.buttonText = template.ButtonText;
        this.fileId = template.FileId;
        this.mailType = template.MailType;
        this.subject = template.Subject;
        this.buttonColor = template.ButtonColor;
        this.buttonForegroundColor = template.ButtonForegroundColor;

        this.mailBGColor = template.MailBGColor;
        this.mailContentBGColor = template.MailContentBGColor;
        this.mailTextColor = template.TextColor;
        this.gtmId = template.GTMId;
        this.gtmCampaignId = template.GTMCampaignId;
        this.gtmCampaignName = template.GTMCampaignName;
        this.useGTMTracking = template.UseGTMTracking;
        this.logoFileId = template.LogoFileId;

        var thisContext = this;

        $("#select_templatetype_" + this.getId()).val(this.mailType);
        $("#select_templatetype_" + this.getId()).trigger('change');

        this.$forceUpdate();

        setTimeout(function () {
          thisContext.resetColorPicker();
        }, 200);

      },
      update() {
        if (!$('#createTemplateMail').valid())
          return false;
        var request = this.getData();

        //alert("data to update:" + JSON.stringify(request))

        try {
          var response = this.$http.post(
            '/api/mailtemplate/Update',
            request
          ).then(response => {
            this.$emit('mail-editor-updated', response.data);
            vm.$root.$emit('mail-editor-updated', response.data);
            this.loadTemplates();
          })
        } catch (err) {
          alert(err);
        }
      },
      apply() {
        var request = this.getData();
        this.$emit('event-apply-email-template', request);
      },
      save() {
        if (!$('#createTemplateMail').valid())
          return false;
        var request = this.getData();

        try {
          var response = this.$http.post(
            '/api/mailtemplate/Create',
            request
          ).then(response => {
            this.$emit('mail-editor-saved', response.data);
            vm.$root.$emit('mail-editor-saved', response.data);
            this.loadTemplates();
          })
        } catch (err) {
          alert(err);
        }
      },
      loadTemplate() {


        if (this.selectedTemplate == '') {

          this.reset();
          return;
        }


        try {
          this.$http.get('/api/MailTemplate/GetMailTemplate?id=' + this.selectedTemplate).then(async response => {
            var template = response.data;
            this.populateData(template);
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      loadTemplates() {
        try {
          this.$http.get('/api/MailTemplate/Search?templateType=' + this.templatetype).then(async response => {
            this.templates = response.data
            if (this.templates != null && this.templates.length > 0) {
              this.selectedTemplate = this.templates[0].Id;
              this.loadTemplate();
              this.apply();
            }
            this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      loadTemplatesType() {
        try {
          this.$http.get('/api/MailTemplate/GetMailTemplatesType').then(async response => {
            this.templatestype = response.data
            this.$forceUpdate();
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      getData() {
        var data =
        {
          Id: this.id,
          Name: this.name,
          Published: this.published,
          body: this.body,
          buttonText: this.buttonText,
          fileId: null,
          mailType: this.mailType,//1,
          subject: this.subject,
          mailBGColor: this.mailBGColor,
          mailContentBGColor: this.mailContentBGColor,
          textColor: this.mailTextColor,
          gtmId: this.gtmId,
          gtmCampaignId: this.gtmCampaignId,
          gtmCampaignName: this.gtmCampaignName,
          useGTMTracking: this.useGTMTracking,
          logoFileId: this.logoFileId,
          buttonColor: this.buttonColor,
          buttonForegroundColor: this.buttonForegroundColor
        }
        return data;
      },


      resetColorPicker() {

        var demoPalette = [
          ["#000", "#444", "#666", "#999", "#ccc", "#eee", "#f3f3f3", "#fff"],
          ["#f00", "#f90", "#ff0", "#0f0", "#0ff", "#00f", "#90f", "#f0f"],
          ["#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#d9d2e9", "#ead1dc"],
          ["#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#b4a7d6", "#d5a6bd"],
          ["#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8e7cc3", "#c27ba0"],
          ["#c00", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3d85c6", "#674ea7", "#a64d79"],
          ["#900", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#0b5394", "#351c75", "#741b47"],
          ["#600", "#783f04", "#7f6000", "#274e13", "#0c343d", "#073763", "#20124d", "#4c1130"]
        ]

        $('.colorpicker-palette-toggle2').spectrum({
          showPalette: true,
          showPaletteOnly: false,
          togglePaletteMoreText: 'More',
          togglePaletteLessText: 'Less',
          palette: demoPalette,
          preferredFormat: "hex",
          cancelText: 'Cancel',
          chooseText: 'Choose',
          showInput: true,
          clickoutFiresChange: true,
          showAlpha: true,
        });
      }


    },
    created() {

    },
    mounted() {
      _componentValidation('#createTemplateMail');
      this.loadTemplates();
      if (this.templatetype === 0 || this.templatetype === null) {
        this.loadTemplatesType();
      }
      this.mailType = this.templatetype;
      $(".colorpicker-palette-toggle2").on('change.spectrum', function (e, tinycolor) {
        $(this).val(tinycolor.toRgbString())
        var e = document.createEvent('HTMLEvents');
        e.initEvent('input', true, true);
        this.dispatchEvent(e);
      });

      $(".colorpicker-palette-toggle2").on('move.spectrum', function (e, tinycolor) {
        $(this).val(tinycolor.toRgbString())
        var e = document.createEvent('HTMLEvents');
        e.initEvent('input', true, true);
        this.dispatchEvent(e);
      });
    },
    computed: {
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/mail/mail-editor-user.vue